export default __webpack_public_path__ + "static/media/contact.4e2e9ef1.svg";